import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';

import initMenu from './components/menu';
import initCookies from './components/cookies';
import initFlickity from './components/flickity-carousels.js';
import initVideoOverlays from './components/video-overlays.js';
import initStickySections from './components/sticky-sections.js';
import initFooterHeight from './components/footer-height.js';

initCookies();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuEl = document.querySelector('.js-menu');

if (menuEl) {
    initMenu(menuEl);
}

const flickityEls = document.querySelectorAll('.js-flickity');

if (flickityEls && flickityEls.length > 0) {
    initFlickity(flickityEls);
}

const videoTriggers = document.querySelectorAll('.js-video-trigger');

if (videoTriggers && videoTriggers.length > 0) {
    initVideoOverlays(videoTriggers);
}

const stickySections = document.querySelectorAll('.js-sticky-section');

if (stickySections && stickySections.length > 0) {
    initStickySections(stickySections);
}

const footer = document.querySelector('.js-footer');

if (footer) {
    initFooterHeight(footer);
}
